import { useState } from 'react'
import { Upload } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteProfileFile,
  profileData,
} from '../../../features/auth/apis/authSlice'
import { uploadFile, removeFile } from '../../../redux/tempUploadSlice'
import { debounce, errorHandling, openNotification } from '../../../utils/utils'

import Popup from '../popups/Popup'
import FileTabGreen from '../FileTabGreen'
import Icon from '../../svgs/Upload'
import InfoCircle from '../../svgs/InfoCircle'

const InstantUploadGeneral = ({
  uploadedFiles,
  uploadedFilesType,
  files,
  setFiles,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { deleteLoading } = useSelector((state) => state.auth)

  const [progress, setProgress] = useState(0)
  const [disabled, setDisabled] = useState(false)
  const [error, setError] = useState(null)

  const [deleteData, setDeleteData] = useState(null)
  const [deleteOpen, setDeleteOpen] = useState(false)

  const handleChange = debounce((newFileList) => {
    setError(null)
    setDisabled(true)

    dispatch(
      uploadFile({
        formData: newFileList,
        onUploadProgress: (progress) => setProgress(progress),
      })
    )
      .unwrap()
      .then((data) => {
        const paths = data.paths
        setFiles([...files, ...paths])
        setDisabled(false)
      })
      .catch((error) => {
        setError(errorHandling(error))
        setDisabled(false)
      })
  }, 300)

  return (
    <>
      <Upload
        className='upload-general-2'
        multiple
        onChange={() => false}
        beforeUpload={(_, FileList) => {
          handleChange(FileList)
          return false
        }}
        disabled={disabled}
      >
        <div
          className={`${
            disabled
              ? 'border-[#DDD] text-[#AAA]'
              : 'bg-green_100 border-green text-green'
          } border border-dashed rounded-lg flex justify-center items-center text-sm py-[0.53rem] md:py-[0.72rem] lg:py-[0.79rem] xl:py-[0.87rem]`}
        >
          <Icon
            styles='w-[1rem] ltr:mr-12 rtl:ml-12'
            color={disabled ? '#AAA' : '#8FC045'}
          />{' '}
          {disabled && progress > 0
            ? `Caricamento file ${progress}%`
            : t('Choose File to Upload')}
        </div>
      </Upload>

      {error && (
        <span className='flex items-center gap-8 text-sm text-danger mt-8'>
          <InfoCircle color='#D93F21' />{' '}
          <span className='hidden sm:block'>{error}</span>
        </span>
      )}

      {files?.length || uploadedFiles?.length ? (
        <div className='flex flex-wrap items-center gap-8 mt-16'>
          {files?.map((path, i) => (
            <FileTabGreen
              key={i}
              index={i}
              fileName={(() => {
                try {
                  return (
                    path.split('/').pop()?.split('-')[5]?.split('.')[0] ??
                    `Documento ${i + 1}`
                  )
                } catch {
                  return `Documento ${i + 1}`
                }
              })()}
              fileLink={`${process.env.NEXT_PUBLIC_IMG_PATH}${path}`}
              onDelete={() => {
                setError(null)
                dispatch(removeFile(path))
                  .unwrap()
                  .then(() => {
                    let filteredArr = files.filter((file) => file !== path)
                    setFiles(filteredArr)
                  })
                  .catch((error) => setError(errorHandling(error)))
              }}
            />
          ))}

          {uploadedFiles?.map((ele, i) => (
            <FileTabGreen
              key={i}
              index={i}
              fileLink={`${process.env.NEXT_PUBLIC_IMG_PATH}${ele.path}`}
              onDelete={() => {
                setDeleteData({
                  fileType: uploadedFilesType,
                  fileID: ele.id,
                })
                setDeleteOpen(true)
              }}
            />
          ))}
        </div>
      ) : null}

      <Popup
        type='danger'
        open={deleteOpen}
        setOpen={setDeleteOpen}
        title={t('Delete File')}
        subTitle={t('Are you sure that you want to delete this file ?')}
        confirmTitle={t('Yes, Delete')}
        loading={deleteLoading}
        onDelete={() => {
          dispatch(deleteProfileFile(deleteData))
            .unwrap()
            .then((data) => {
              openNotification('success', data.message)
              dispatch(profileData())
              setDeleteOpen(false)
            })
            .catch((error) => openNotification('error', errorHandling(error)))
        }}
      />
    </>
  )
}

export default InstantUploadGeneral
